import React, { Component } from "react";
import { CLIENT_INFO_UPDATE } from "./../helper/Constants";
import Apihelpers from "./../helper/ApiHelper";
import { Alert } from 'rsuite';
//import { reactLocalStorage } from 'reactjs-localstorage';
//import { Textbox, Textarea } from 'react-inputs-validation';
import $ from "jquery";
//import Select2 from 'react-select2-wrapper';

export default class ClientConfUpdate extends Component {
  constructor(props) {
    super(props);
    let bbuserInfo = this.props.bbUserData || {};
    let ips = [];
    if (bbuserInfo.allowed_ip_addresses?.length > 0) {
      ips = bbuserInfo.allowed_ip_addresses.split(",");
    }
    this.state = {
      //userData: this.props.userData || {},
      bbUserData: this.props.bbUserData || {},
      bbActivePlan: JSON.parse(bbuserInfo.active_plan),

      //hasupdateNumberError: false,
      //hasUpdateAddressError: false,

      //updateMobileNumber: this.props.userData.contact_number,
      //updateAddress: this.props.userData.address,
      updateUserId: this.props.bbUserData.userid,

      send_make_model_id:bbuserInfo.send_make_model_id,
      send_make_model_suggestion_id:bbuserInfo.send_make_model_suggestion_id,
      send_challan_fasttag_details:bbuserInfo.send_challan_fasttag_details,
      rc_prime_retry_call:bbuserInfo.rc_prime_retry_call,
      is_send_incomplete_rcprime_vehicle_info:bbuserInfo.is_send_incomplete_rcprime_vehicle_info,
      rc_prime_response_user_specific_return_format:bbuserInfo.rc_prime_response_user_specific_return_format,
      free_rc_api_hit_allow:bbuserInfo.free_rc_api_hit_allow,
      third_party_call_in_rc:bbuserInfo.third_party_call_in_rc,
      rc_prime_third_party_call_enable:bbuserInfo.rc_prime_third_party_call_enable,
      allowed_ip_addresses_for_rc_prime:ips,
      ip_address_enable_for_rc_prime: bbuserInfo.ip_address_enable
    }
  }

  componentDidMount() {
    $("#allowed_ip_address").select2({
      placeholder: "type ip",
      tags: true,
      tokenSeparators: [',', ' ']
    });
  }

  updateClientProfileInfo = (e) => {
    e.preventDefault();
    //this.toggleUpdateValidating(true);
    //if (!this.state.hasupdateNumberError && !this.state.hasUpdateAddressError) {
      let updatepostdata = {
        userid: this.state.updateUserId,
        //contact: this.state.updateMobileNumber,
        //address: this.state.updateAddress,
        send_make_model_id: this.state.send_make_model_id,
        send_make_model_suggestion_id: this.state.send_make_model_suggestion_id,
        send_challan_fasttag_details: this.state.send_challan_fasttag_details,
        rc_prime_retry_call: this.state.rc_prime_retry_call,
        is_send_incomplete_rcprime_vehicle_info: this.state.is_send_incomplete_rcprime_vehicle_info,
        rc_prime_response_user_specific_return_format: this.state.rc_prime_response_user_specific_return_format,
        free_rc_api_hit_allow: this.state.free_rc_api_hit_allow,
        third_party_call_in_rc: this.state.third_party_call_in_rc,
        rc_prime_third_party_call_enable:this.state.rc_prime_third_party_call_enable
      };
      if ($("#allowed_ip_address").val() !== undefined) {
        updatepostdata.ip_address_enable = this.state.ip_address_enable_for_rc_prime; 
        updatepostdata.allowed_ip_addresses = $("#allowed_ip_address").val().toString();
      }
      console.log('updatepostdata',updatepostdata);
      $('.loader').css('display', 'block');
      //return;
      //if (this.state.password !== "" && this.state.email !== "") {
        Apihelpers.postdataresponse("bbuser/updateClientConfigInfo", updatepostdata).then(res => {
          if (res.data.status === true) {
            Alert.success("Client Configuration Successfully Updated");
            setTimeout(function(){
              window.location.reload();
            },1000);
            //this.loadClientEditDetail(this.props.match.params.someid);
          } else {
            Alert.error("Error While Update Client Info");
          }
        });
      //}
    //}
  }

  render() {
    return (
      <>
        {
          //JSON.stringify(this.state.bbUserData, null,2)
        }
        <div className="customPopup" style={{'display':'block'}}>
          <div className="bgLayer" />
          <div className="popUpBox" style={{ maxWidth: "770px" }}>
            <span className="closeIcon" onClick={this.props.hideUpdateModel} > </span>
            <div className="popScroll" style={{ padding: "20px 20px 30px 20px" }}>
              <div className="popUpHed">
                <h3>{this.state.bbUserData.business_name}</h3>
                <div className="desc">Configuration Update</div>
              </div>
              <form className="form" method="post" onSubmit={this.updateClientProfileInfo}>
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label className="form-title">Allowed Ip Address</label>
                      <div className="formSwithc">
                        <label className="switch">
                          <input name="" type="checkbox" onChange={(e) => this.setState({ ip_address_enable_for_rc_prime: e.target.checked })} checked={this.state.ip_address_enable_for_rc_prime} />
                          <span className="slider round"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group" style={(this.state.ip_address_enable_for_rc_prime) ? { 'display': 'block' } : { 'display': 'none' }}>
                      <label className="form-title">Select IP</label>
                      <select className="form-control selectInput" multiple="multiple" id="allowed_ip_address" style={{ width: "100%" }} defaultValue={this.state.allowed_ip_addresses_for_rc_prime}>
                        {this.state.allowed_ip_addresses_for_rc_prime.map((ip, i) => {
                          if (ip.length > 0) {
                            return <option key={i}>{ip}</option>
                          }
                        })}
                      </select>
                    </div>
                  </div>
                </div>
                <div>
                    <div className="row">
                      <div className="col-4">
                        <div className="form-group">
                          <label className="form-title">Send Make Model ID</label>
                          <div className="formSwithc">
                            <label className="switch">
                              <input name="send_make_model_id" type="checkbox" onChange={(e) => this.setState({ send_make_model_id: e.target.checked })} checked={this.state.send_make_model_id} />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="form-group">
                          <label className="form-title">Send Make Model Suggestion ID</label>
                          <div className="formSwithc">
                            <label className="switch">
                              <input name="send_make_model_suggestion_id" type="checkbox" onChange={(e) => this.setState({ send_make_model_suggestion_id: e.target.checked })} checked={this.state.send_make_model_suggestion_id} />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="form-group">
                          <label className="form-title">Is send incomplete rcprime vehicle info</label>
                          <div className="formSwithc">
                            <label className="switch">
                              <input name="is_send_incomplete_rcprime_vehicle_info" type="checkbox" onChange={(e) => this.setState({ is_send_incomplete_rcprime_vehicle_info: e.target.checked })} checked={this.state.is_send_incomplete_rcprime_vehicle_info} />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="form-group">
                          <label className="form-title">Send Challan FASTag Details</label>
                          <div className="formSwithc">
                            <label className="switch">
                              <input name="send_challan_fasttag_details" type="checkbox" onChange={(e) => this.setState({ send_challan_fasttag_details: e.target.checked })} checked={this.state.send_challan_fasttag_details} />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="form-group">
                          <label className="form-title">RC Prime Retry Call</label>
                          <div className="formSwithc">
                            <label className="switch">
                              <input name="rc_prime_retry_call" type="checkbox" onChange={(e) => this.setState({ rc_prime_retry_call: e.target.checked })} checked={this.state.rc_prime_retry_call} />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-4">
                        <div className="form-group">
                          <label className="form-title">Free RC API hit allow</label>
                          <div className="formSwithc">
                            <label className="switch">
                              <input name="free_rc_api_hit_allow" type="checkbox" onChange={(e) => this.setState({ free_rc_api_hit_allow: e.target.checked })} checked={this.state.free_rc_api_hit_allow} />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="form-group">
                          <label className="form-title">Third party call in Free RC</label>
                          <div className="formSwithc">
                            <label className="switch">
                              <input name="third_party_call_in_rc" type="checkbox" onChange={(e) => this.setState({ third_party_call_in_rc: e.target.checked })} checked={this.state.third_party_call_in_rc} />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-4">
                        <div className="form-group">
                          <label className="form-title">RcPrime response user specific return format</label>
                          <div className="formSwithc">
                            <label className="switch">
                              <input name="rc_prime_response_user_specific_return_format" type="checkbox" onChange={(e) => this.setState({ rc_prime_response_user_specific_return_format: e.target.checked })} checked={this.state.rc_prime_response_user_specific_return_format} />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="form-group">
                          <label className="form-title">RC Prime Third party Call Enable</label>
                          <div className="formSwithc">
                            <label className="switch">
                              <input name="rc_prime_third_party_call_enable" type="checkbox" onChange={(e) => this.setState({ rc_prime_third_party_call_enable: e.target.checked })} checked={this.state.rc_prime_third_party_call_enable} />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
                
                <div className="submitRow">
                  <button className="backBtn" onClick={this.props.hideUpdateModel} type="button">Cancel</button>
                  <button className="blueBtn" type="submit">Update</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    )
  }
}

